import { styled } from '@material-ui/core';
import ReplayIcon from '@material-ui/icons/Replay';

export const LoadMoreContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-evenly',
  alignItems: 'center',
  width: 300,
  borderRadius: 16,
  background: '#fff',
  cursor: 'pointer',
  minHeight: 350,
});

export const StyledReplayIcon = styled(ReplayIcon)({
  fontSize: 150,
  transform: 'rotateY(180deg)',
});
